module.exports = __webpack_public_path__ + "static/blue-block-88a9ea2bbba384a75bf466a88cca69ca.svg";